export let FilterType = /*#__PURE__*/function (FilterType) {
  FilterType["CompanyName"] = "companyName";
  FilterType["AgreementName"] = "agreement";
  FilterType["IssueDate"] = "issueDate";
  FilterType["DueDate"] = "dueDate";
  FilterType["RequiresApproval"] = "requiresApproval";
  return FilterType;
}({});
export const filterLabels = {
  [FilterType.CompanyName]: 'Company name',
  [FilterType.AgreementName]: 'Agreement name',
  [FilterType.IssueDate]: 'Issue date',
  [FilterType.DueDate]: 'Due date',
  [FilterType.RequiresApproval]: 'Requires approval'
};
export let RequiresApproval = /*#__PURE__*/function (RequiresApproval) {
  RequiresApproval["Yes"] = "Yes";
  RequiresApproval["No"] = "No";
  return RequiresApproval;
}({});
export let FutureInvoicesReportSortColumnId = /*#__PURE__*/function (FutureInvoicesReportSortColumnId) {
  FutureInvoicesReportSortColumnId["CompanyName"] = "companyName";
  FutureInvoicesReportSortColumnId["IssueDate"] = "issueDate";
  FutureInvoicesReportSortColumnId["DueDate"] = "dueDate";
  FutureInvoicesReportSortColumnId["RequiresApproval"] = "requiresApproval";
  FutureInvoicesReportSortColumnId["Total"] = "total";
  return FutureInvoicesReportSortColumnId;
}({});